import React from 'react'
import Navbar from './Navber.jsx'
import HeroSection from "./HeroSection.jsx"
import Services from './Services.jsx'
import Gallery from './Gallery.jsx'
import Projects from './Projects.jsx'
import Testimonials from './Testimonials.jsx'
import AboutSection from './About.jsx'
import ContactBanner from './Contact.jsx'
import AvailableProperty from './AvailableProperty.jsx'
import BuildTogether from './BuildTogether.jsx'
import ProjectQuote from './ProjectQuote.jsx'


function HomeMain() {
  return (
    <div>
       <HeroSection/> 
       <ProjectQuote/>
       <AvailableProperty/>
       {/* <Services/> */}
       <AboutSection/>
       {/* <Projects/> */}
       <Gallery/>
       {/* <Stats/> */}
        <BuildTogether/>
       <Testimonials/>
       <ContactBanner/>
    </div>
  )
}

export default HomeMain